/// <reference lib="dom" />
import * as d3 from "d3";
import { LfoCycles, LfoValue } from "@wbaudio/utils";
import { type Chart, type ChartLayer, CreateChart } from "../../core/chart.ts";
import { type ChartMode, EditorSize, ModeSize, ModeTheme, PadMargin } from "../../core/mode.ts";
import { RefLineLayer } from "../../layers/refLine.ts";
import type { LineDatum } from "../../layers/lines.ts";
import { SampleDomain } from "../../utils/sample.ts";
import type { ChartTheme } from "../../utils/theme.ts";

export const LfoDisplay = { maxCycles: 4, rateMin: 0.01, rateMax: 11 };

export const LfoEditorSize = EditorSize(10, 4);

export interface LfoChartOpts {
  mode: ChartMode;
  layers: ChartLayer[];
  theme?: ChartTheme;
}

export function CreateLfoChart(container: HTMLElement, opts: LfoChartOpts): Chart {
  const size = ModeSize(opts.mode, LfoEditorSize);
  return CreateChart(container, {
    width: size.width,
    height: size.height,
    margin: PadMargin(size.pad),
    x: d3.scaleLinear().domain([0, 1]),
    y: d3.scaleLinear().domain([-1, 1]),
    theme: ModeTheme(opts.mode, opts.theme),
    layers: [
      ...(opts.mode === "editor" ? [RefLineLayer({ axis: "y", value: 0 })] : []),
      ...opts.layers,
    ],
  });
}

export function LfoPoints(
  rate: number,
  depth: number,
  rateMin: number,
  rateMax: number,
  phaseDeg = 0,
): LineDatum[] {
  const cycles = LfoCycles(rate, rateMin, rateMax, LfoDisplay.maxCycles);
  return SampleDomain((t) => LfoValue(t, cycles, depth, phaseDeg), [0, 1], 80);
}

export function LfoHandleScales(rateMin: number, rateMax: number) {
  return {
    x: d3.scaleLinear().domain([rateMin, rateMax]),
    y: d3.scaleLinear().domain([0, 1]),
  };
}
